import React, { Component, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import gbParams from '../../config/parameters';
import config from "../../config/config";
import '../../assets/stylesheets/LoginPage.scss';

const ManualLogin = ({ }) => {
    const { t } = useTranslation();
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [skinId, setSkinId] = useState('');
    const [token, setToken] = useState('');

    const login = (e) => {
        if (e.key === 'Enter') loginUser();
    }
    const openApp = () => {
        window.open(`${window.location.origin}/autoLogin/${skinId || config.globalSkinId}/${username}/${token}`, '', [
            'width=' + gbParams.dimensions.app.width,
            'height=' + gbParams.dimensions.app.height,
            'resizable=0',
            'scrollbars=1',
            'top=' + (window.screen.height - gbParams.dimensions.app.height - 100) / 2,
            'left=' + (window.screen.width - gbParams.dimensions.app.width) / 2
          ].toString());
    }

    const loginUser = () => {

        axios.post(`${config.API_URL}/club/authenticate`, {
            username,
            password,
            skinId: skinId || config.globalSkinId
        })
            .then(response => {
                const authData = response.data.result.authenticationData;
                let gbAccount = authData.find(acc => acc.isGlobal);
                console.log('gbAccount: ', gbAccount);
                setToken(gbAccount.token);
            })
            .catch(err => {
                console.error(err);
            });

    };

    return (
        <div className="mainLogin autoLogin" onKeyUp={login}>
            {
                token ? <div>
                    <div>{`${t('tokenIsReceived')}..!`}</div>
                    <div className={`login`}>
                        <button onClick={openApp} className={`primary`} >{t('openApp')}</button>
                    </div>
                </div> :
                    <div>
                        <div className='inputSection'>
                            <div className="userNameField">
                                {'SkinID'}
                                <label>
                                    <input type='text' className="userNameInput" placeholder={'Skin ID'}
                                        onChange={(e) => setSkinId(e.target.value)}
                                    />
                                </label>
                            </div>
                            <div className="userNameField">
                                {t('signInUp.username')}
                                <label>
                                    <input type='text' className="userNameInput" placeholder={t('signInUp.username')}
                                        onChange={(e) => setUserName(e.target.value)}
                                    />
                                </label>
                            </div>
                            <div className="passwordField">
                                {t('signInUp.password')}
                                <label>
                                    <input type='password' placeholder={t('signInUp.password')} onChange={(e) => setPassword(e.target.value)} />
                                </label>
                            </div>
                        </div>
                        <div className={`login`}>
                            <button onClick={loginUser} className={`primary`} > {t('login')}</button>
                        </div>
                    </div>
            }
        </div>
    );
}

export default ManualLogin;
